// frontend/src/config.js
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || API_URL;
const SHOP_SOURCE = process.env.REACT_APP_SHOP_SOURCE || 'api';
const TOURNAMENTS_SOURCE = process.env.REACT_APP_TOURNAMENTS_SOURCE || 'api';

const API_BASE_PATH = '/api';
const API_BASE_URL = `${API_URL}${API_BASE_PATH}`;

export { API_URL, SOCKET_URL, TOURNAMENTS_SOURCE, SHOP_SOURCE, API_BASE_PATH, API_BASE_URL };

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line no-console
  console.log(
    '[frontend] API_URL =', API_URL,
    ' | SOCKET_URL =', SOCKET_URL,
    ' | TOURNAMENTS_SOURCE =', TOURNAMENTS_SOURCE,
    ' | SHOP_SOURCE =', SHOP_SOURCE,
    ' | API_BASE_URL =', API_BASE_URL
  );
 }
